import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Observable } from 'rxjs';
import { getContractsResponse, getContractResponse, getContractForUpdateResponse, updateContractResponse, createBatchesPayload, createBatchResponse, getRequestCountResponse, batchActionRequestPayload, batchActionRequestResponse, changeAdminRolePayload, changeAdminRoleResponse, syncPrimerlandPayload, syncPrimerlandResponse } from './contract.types';
import { environment } from '../../../environments/environment';
import { ENDPOINT } from '../../shared/routes/end-points';
import { TContract } from '../../shared/models';
import { io, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  private socket: Socket;

  constructor(private service: ApiService) { 
    this.socket = io(`${environment.BASEURL}framework`);
  }

  getContracts(userId?: string, limit: number = 10, offset: number = 0): Observable<getContractsResponse> {
    const query = userId
      ? `?userId=${userId}&limit=${limit}&offset=${offset}`
      : `?limit=${limit}&offset=${offset}`;
  
    return this.service.get<getContractsResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.GETALL}${query}`);
  }

  getContract(contractId: string): Observable<getContractResponse> {
    return this.service.get<getContractResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.GET}?id=${contractId}`);
  }
  
  getContractForUpdate(contractId: string): Observable<getContractForUpdateResponse> {
    return this.service.get<getContractForUpdateResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.GETFORUPDATE}?id=${contractId}`);
  }

  updateContract(payload: Partial<TContract>): Observable<updateContractResponse> {
    return this.service.put<Partial<TContract>, updateContractResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.UPDATE}`, payload);
  }

  createBatches(payload: createBatchesPayload): Observable<createBatchResponse> {
    return this.service.post<createBatchesPayload, createBatchResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.CREATEBATCHES}`, payload);
  }

  getRequestCount(userId: string): Observable<getRequestCountResponse> {
    return this.service.get<getRequestCountResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.GETREQUESTCOUNT}?userId=${userId}`);
  }

  batchActionRequest(payload: batchActionRequestPayload): Observable<batchActionRequestResponse> {
    return this.service.put<batchActionRequestPayload, batchActionRequestResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.BATCHACTIONREQUEST}`, payload);
  }

  getMessages(socket: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(socket, (message: any) => {
        observer.next(message);
      });
    });
  }

  disconnectSocket(){
    if(this.socket){
      this.socket.disconnect();
    }
  }

  changeAdminRole(payload: changeAdminRolePayload): Observable<changeAdminRoleResponse> {
    return this.service.put<changeAdminRolePayload, changeAdminRoleResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.CHANGEADMINROLE}`, payload);
  }

  syncPrimerland(payload: syncPrimerlandPayload): Observable<syncPrimerlandResponse> {
    return this.service.post<syncPrimerlandPayload, syncPrimerlandResponse>(`${environment.BASEURL}${ENDPOINT.CONTRACT.SYNCPRIMERLAND}`, payload);
  }

}
